import ContextMenu from './ContextMenu.js';
import { fabric } from 'fabric';

class Editor {
  canvas;
  store;
  contextMenu;
  pluginMap = {};

  constructor(canvas, store) {
    this.canvas = canvas;
    this.store = store;
  }

  init() {
    this._initContextMenu();
    this._bindContextMenu();
  }

  // 引入组件
  use(plugin, options) {
    const pluginRunTime = new plugin(this.canvas, this, options);
    this.pluginMap[plugin.pluginName] = pluginRunTime;
  }

  // 获取插件
  getPlugin(name) {
    if (this.pluginMap[name]) {
      return this.pluginMap[name];
    }
  }

  // 右键菜单
  _bindContextMenu() {
    this.canvas.on('mouse:down', () => {
      this.contextMenu.hideAll();
    });
    document.body.addEventListener('click', () => {
      this.contextMenu.hideAll();
    });
    fabric.util.addListener(document.querySelector('.upper-canvas'), 'contextmenu', e => {
      let menu = [];
      Object.keys(this.pluginMap).forEach(pluginName => {
        const pluginRunTime = this.pluginMap[pluginName];
        const pluginMenu = pluginRunTime.contextMenu && pluginRunTime.contextMenu();
        if (pluginMenu) {
          menu = menu.concat(pluginMenu);
        }
      });
      this._renderMenu(e, menu);
    });
  }

  // 渲染右键菜单
  _renderMenu(e, menu) {
    if (menu.length !== 0) {
      this.contextMenu.hideAll();
      this.contextMenu.setData(menu);
      this.contextMenu.show(e.clientX, e.clientY);
    }
  }

  _initContextMenu() {
    const els = document.querySelectorAll('.panzoom');
    this.contextMenu = new ContextMenu(els[els.length - 1], []);
    this.contextMenu.install();
  }
}

export default Editor;
